import React from "react";

import { useRoutes } from "react-router-dom"
import Projects from "../pages/projects";
import Blogs from "../pages/blogs";
import Home from "../pages/home";
import NoMatch from "../pages/no-match";
import './Routes.css';

const routes = [
    {
        path: "/",
        children: [
            { index: true, element: <Home /> },
            {
                path: "/home", element: <Home />
            },
            {
                path: "/projects", element: <Projects />,
            },
            // {
            //     path: "/papers", element: <Projects />,
            // },
            {
                path: "/blogs", element: <Blogs />
            },
            {
                path: "*", element: <NoMatch />
            },
        ],
    },
];

const Routes = () => {
    const routeElement = useRoutes(routes);
    return (
        <div className="Routes">
            {routeElement}
        </div>
        // <Switch>
        //     <Route path="/" element={<Home />} />
        //     <Route path="/projects" element={<Projects />} />
        //     <Route path="/blogs" element={<Blogs />} />
        // </Switch>
    );
}

export default Routes;